export enum DeliveryModeEnum {
  STANDARD = 'STANDARD',
  RELAYPOINT = 'WITHDRAWAL_POINT',
  REPAIR = 'REPAIR',
  EXPRESS = 'EXPRESS',
  NONE = 'NONE'
}
